import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ALERT_FEATURE_KEY, AlertState, alertAdapter } from './alert.reducer';
import { AlertType } from '@surface-elements/shared/alert-system/domain';

export const selectAlertState =
  createFeatureSelector<AlertState>(ALERT_FEATURE_KEY);

const { selectAll, selectEntities, selectIds, selectTotal } =
  alertAdapter.getSelectors();

export const selectAllAlerts = createSelector(selectAlertState, selectAll);

export const selectAlertEntities = createSelector(
  selectAlertState,
  selectEntities,
);

export const selectAlertIds = createSelector(selectAlertState, selectIds);

export const selectAlertTotal = createSelector(selectAlertState, selectTotal);

export const selectAlertConfig = createSelector(
  selectAlertState,
  state => state.config,
);

export const selectAlertsLoaded = createSelector(
  selectAlertState,
  state => state.loaded,
);

export const selectAlertError = createSelector(
  selectAlertState,
  state => state.error,
);

export const selectAlertsByType = (type: AlertType) =>
  createSelector(selectAllAlerts, alerts =>
    alerts.filter(alert => alert.type === type),
  );

export const selectDismissibleAlerts = createSelector(selectAllAlerts, alerts =>
  alerts.filter(alert => alert.dismissible),
);

export const selectAlertById = (id: string) =>
  createSelector(selectAlertEntities, entities => entities[id]);
